import { createContext, PropsWithChildren, use, useMemo } from "react";
import { Editor } from "@tiptap/react";

interface IEditorContext {
  editor: Editor | null;
}

const EditorContext = createContext<IEditorContext>(undefined as never);

export const useCurrentEditor = () => use(EditorContext);

interface Props {
  editor: Editor | null;
}

export function EditorProvider({ children, editor }: PropsWithChildren<Props>) {
  const context = useMemo(() => ({ editor }), [editor]);

  return <EditorContext value={context}>{children}</EditorContext>;
}
